// src/assets/mksMITOCWData.ts
// export const mksMITOCWData = [
//     {
//         name: 'MIT OCW',
//         id: '5beed530-11f0-486b-9cd2-ea82e6ac95e1',
//         siteName: 'mit',
//     },
// ];

export const mksMITOCWData = [
    {
        env: 'dev',
        data: [
            {
                name: 'MIT OCW',
                id: '3e71017c-5074-4e39-a406-e1d453b88ff2',
                siteName: 'mit',
            },
        ],
    },
    {
        env: 'qa',
        data: [
            {
                name: 'MIT OCW',
                id: '08e63b53-118a-47f3-bf36-97024ca05b46',
                siteName: 'mit',
            },
        ],
    },
    {
        env: 'prod',
        data: [
            {
                name: 'MIT OCW',
                id: '73161bfb-cfd1-407e-b321-918f63db9ea7',
                siteName: 'mit',
            },
        ],
    },
];
